Object.defineProperty(exports, "__esModule", { value: true });
var browser_1 = require("@sentry/browser");
/**
 * Inits the React SDK
 */
function init(options) {
    options._metadata = options._metadata || {};
    if (options._metadata.sdk === undefined) {
        options._metadata.sdk = {
            name: 'sentry.javascript.react',
            packages: [
                {
                    name: 'npm:@sentry/react',
                    version: browser_1.SDK_VERSION,
                },
            ],
            version: browser_1.SDK_VERSION,
        };
    }
    browser_1.init(options);
}
exports.init = init;
//# sourceMappingURL=sdk.js.map